import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const PUZZLE_PIECES_ACTIVITY_FRAGMENT = gql `
  fragment PuzzlePiecesActivityFragment on PuzzlePiecesActivity {
    rounds {
      id
      puzzlePieceCards {
        answerAudio {
          id
          audio {
            ...AssetFragment
          }
        }
        answerImage {
          id
          image {
            ...AssetFragment
          }
        }
        label
        letterCard {
          id
          image {
            ...AssetFragment
          }
        }
        puzzlePiece {
          full {
            id
            image {
              ...AssetFragment
            }
          }
          missing {
            id
            image {
              ...AssetFragment
            }
          }
          width
          x
          y
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default PUZZLE_PIECES_ACTIVITY_FRAGMENT;
